import type { ChatMessage, OrchestratorMessage } from "../types/conversationTypes";

export const toChatMessage = (m: OrchestratorMessage): ChatMessage => ({
  id: m.id,
  content: m.content,
  isUser: m.sender === "user",
  timestamp: new Date(m.timestamp),
  images: m.images?.map(img => img.url),
});

export const lastAiMessage = (messages: OrchestratorMessage[]): OrchestratorMessage | undefined =>
  [...messages].reverse().find(m => m.sender === "orchestrator");
